import { createPopper } from '@popperjs/core';
import DOMPurify from 'dompurify';

export default function MultiList(params) {
    const { value, splitter, innerMethods } = params;
    const multiValueCell = document.createElement('div');
    multiValueCell.classList.add('w5-multi-value-cell');
    if (!value) return multiValueCell;
    let list = [];
    if (innerMethods?.getValues) {
        list = innerMethods.getValues(value);
        if (!list) return multiValueCell;
    } else if (Array.isArray(value)) {
        if (value.length === 0) return multiValueCell;
        list = value;
    } else if (typeof value === 'string') {
        if (splitter) {
            list = value.split(splitter);
        } else list = value.split(';');
    } else return multiValueCell;

    const firstValue = list[0];

    const extraValues = list.slice(1);

    const firstValueElement = document.createElement('div');
    firstValueElement.classList.add('w5-multi-value-first-value');
    firstValueElement.innerText = firstValue;

    multiValueCell.appendChild(firstValueElement);

    if (extraValues.length > 0) {
        const extraValuesString = ` +${extraValues.length}`;
        const extraValuesElement = document.createElement('div');
        extraValuesElement.classList.add('w5-multi-value-cell__extra-values');
        extraValuesElement.innerText = extraValuesString;
        multiValueCell.appendChild(extraValuesElement);
        addPopover(extraValuesElement, extraValues, params.context);
    }

    return multiValueCell;
}

const createPopoverContent = (extraValues) => {
    const elements = extraValues.map((current, index) => {
        const marginTop = index > 0 ? '5px' : '0px';
        return `<div class="w5-multi-value-cell__extra-values-popover-item" style="margin-top: ${marginTop}">
                    ${DOMPurify.sanitize(current)}
                </div>`;
    });

    const wrapper = `<div class="w5-multi-value-cell__extra-values-popover-wrapper">
                        ${elements.join('')}
                    </div>`;

    return wrapper;
};

const addPopover = (cell, extraValues, context) => {
    if (!extraValues || extraValues.length === 0) return;
    const element = context?.tableId ? document.querySelector(`#${context?.tableId}`) : document;
    const popover = element.querySelector('.w5-popover');
    let popperInstance = null;

    const popoverContent = createPopoverContent(extraValues);

    cell.addEventListener('mouseover', () => {
        popover.style.display = 'block';
        popover.firstElementChild.innerHTML = popoverContent.toString();
        let placement = 'bottom';

        createPopper(cell, popover, {
            placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 5],
                    },
                },
            ],
        });
    });

    cell.addEventListener('mouseout', () => {
        popover.style.display = 'none';
        if (popperInstance) {
            popperInstance.destroy();
            popperInstance = null;
        }
    });
};
